module.exports = __webpack_public_path__ + "img/product_11.f4e9581.webp";